import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Star, FileText, Zap, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-28 overflow-hidden bg-gradient-to-b from-peach-light via-cream to-cream" data-id="element-164">
      <div className="absolute top-20 left-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-165">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-peach" data-id="element-166"></div>)}
      </div>
      <div className="absolute top-40 right-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-167">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-sage" data-id="element-168"></div>)}
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-170">
          <span className="inline-flex items-center gap-2 text-sm font-bold tracking-[0.3em] text-peach-dark uppercase" data-id="element-171">
            <span className="text-yellow-500" data-id="element-172">⭐</span>
            AULA MATER
            <span className="text-yellow-500" data-id="element-173">⭐</span>
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto" data-id="element-174">
          <div className="absolute inset-0 bg-gradient-to-tr from-peach/10 to-sage/10 rounded-[3rem] blur-3xl scale-105" data-id="element-175"></div>
          <img src="https://cdn.magicpatterns.com/uploads/76ZivY5Ak2vvGUrtvkTRDF/imagen_hero.png" alt="Florecer - La guía real que toda mamá primeriza necesita desde el primer día" className="relative z-10 w-full rounded-[2rem] shadow-2xl shadow-peach/20" data-id="element-176" />
        </motion.div>

        {/* Trust badges row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mt-10" data-id="element-177">
          <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white rounded-full shadow-sm border border-peach-light/60 text-sm font-medium text-text-dark" data-id="element-178">
            <FileText className="w-4 h-4 text-peach" data-id="element-179" /> 100% PDF
          </span>
          <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white rounded-full shadow-sm border border-peach-light/60 text-sm font-medium text-text-dark" data-id="element-180">
            <Zap className="w-4 h-4 text-peach" data-id="element-181" /> Acceso en 5 min
          </span>
          <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white rounded-full shadow-sm border border-peach-light/60 text-sm font-medium text-text-dark" data-id="element-182">
            <MapPin className="w-4 h-4 text-peach" data-id="element-183" /> Hecho en Argentina
          </span>
        </motion.div>

        {/* Benefits chips row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mt-6 max-w-3xl mx-auto" data-id="element-184">
          {['Menos miedo', 'Más claridad mental', 'Menos ansiedad', 'Más tranquilidad', 'Más confianza en vos'].map((chip, idx) => <span key={idx} className="inline-flex items-center gap-1.5 px-4 py-2 bg-peach-bg/60 rounded-full text-sm text-text-dark border border-peach-light/40" data-id="element-185">
              <span data-id="element-186">🌸</span> {chip}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-12" data-id="element-187">
          <a href="#pricing" className="inline-flex justify-center items-center px-10 py-5 bg-peach text-white font-bold rounded-full hover:bg-peach-dark transition-colors shadow-xl shadow-peach/30 text-lg tracking-wide" data-id="element-188">
            QUIERO MI GUÍA AHORA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-text-muted mt-6" data-id="element-189">
            <span className="flex items-center gap-1" data-id="element-190">
              <Shield className="w-4 h-4" data-id="element-191" /> Garantía 7 días
            </span>
            <span className="text-peach/30" data-id="element-192">•</span>
            <span data-id="element-193">Pago seguro</span>
            <span className="text-peach/30" data-id="element-194">•</span>
            <span data-id="element-195">Mercado Pago</span>
          </div>

          <div className="inline-flex items-center gap-3 text-sm text-text-muted mt-4 bg-white/60 px-5 py-2.5 rounded-full" data-id="element-196">
            <span data-id="element-197">+2.000 mamás</span>
            <span className="text-peach/30" data-id="element-198">•</span>
            <span data-id="element-199">6 capítulos</span>
            <span className="text-peach/30" data-id="element-200">•</span>
            <span data-id="element-201">4 bonus</span>
            <span className="text-peach/30" data-id="element-202">•</span>
            <span className="flex items-center text-yellow-500 font-medium" data-id="element-203">
              <Star className="w-3.5 h-3.5 fill-current mr-1" data-id="element-204" /> 4.9/5
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}